module.exports = __webpack_public_path__ + "07_mole.728e279a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer2/07_mole.png
// module id = z4ud
// module chunks = 0